import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Table, Button } from 'react-bootstrap';

import { INIT_INDEX, DOUBLE } from 'util/constants';

import TableSelectorItem from 'components/ui/form/dates/lib/TableSelectorItem';
import Icon from 'components/ui/element/Icon';

const
    COLS = 3,
    ROWS = 4,
    MAX_PAGE = COLS * ROWS,
    DIFF_PREV = -1,
    DIFF_NEXT = 1;

const _getArrowDisableClass = (textMonth, currentYear) => {
    const RADIX = 10;

    if (parseInt(textMonth, RADIX) === currentYear) {
        return 'arrow-disable';
    }

    return '';
};

/** Component to show a table with its cells being clickable */
class TableSelector extends Component {

    static propTypes = {
        textMenu:     PropTypes.string, // The text to show at the top menu
        items:        PropTypes.array.isRequired, // The items to show. Max 12, if there is more else they won't be shown
        defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.number]), // The default selected month
        onChange:     PropTypes.func, // Listener for when the selection has changed
        onClickTitle: PropTypes.func, // Listener for when the title has been clicked
        onClickMenu:  PropTypes.func, // Listener for when any menu button has been clicked
        selectedDate: PropTypes.number // The selected day to show
    };

    state = {
        selected: undefined, // The selected item
        initItem: undefined // The initial item to show
    };

    /**
     * Init the state
     * Set this to handlers
     */
    componentWillMount() {
        const { defaultValue } = this.props;

        this.setState({
            selected: defaultValue,
            initItem: this.getDefaultInitItem(defaultValue)
        });

        this.handleClick = this.handleClick.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handlePrevious = this.handlePrevious.bind(this);
    }

    /**
     * Updates the state when the defaultValue has changed
     */
    componentWillReceiveProps(nextProps) {
        const { defaultValue } = this.props;

        (nextProps.defaultValue !== defaultValue) && this.setState({
            selected: nextProps.defaultValue,
            initItem: this.getDefaultInitItem(defaultValue)
        });
    }

    /**
     * Fire the change event when a different month is selected also change the state
     * @param value
     */
    handleClick(value) {
        const
            { onChange } = this.props,
            { selected } = this.state,
            retChange = value !== selected && onChange && onChange(value, selected);

        if (retChange !== false) {
            this.setState({
                selected: value
            });
        }
    }

    /**
     * Fire the clickMenu event passing the prev movement also change the state
     */
    handlePrevious() {
        const
            { onClickMenu } = this.props,
            { initItem } = this.state,
            newInitItem = initItem - MAX_PAGE,
            resClick = onClickMenu && onClickMenu(DIFF_PREV);

        if (resClick !== false) {
            this.setState({
                initItem: newInitItem < INIT_INDEX ? INIT_INDEX : newInitItem
            });
        }
    }

    /**
     * Fire the clickMenu event passing the next movement also change the state
     */
    handleNext() {
        const
            { initItem } = this.state,
            { onClickMenu } = this.props,
            { items } = this.props,
            newInitItem = initItem + MAX_PAGE,
            resClick = onClickMenu && onClickMenu(DIFF_NEXT);

        if (resClick !== false) {
            this.setState({
                initItem: newInitItem > items.length - MAX_PAGE ? items.length - MAX_PAGE : newInitItem
            });
        }

    }

    /**
     * Get the default value for the table choosing the first one when noelse was passed
     * @param {object} defaultValue The defaultValue
     * @returns {number} The position of the default value
     */
    getDefaultInitItem(defaultValue) {
        const
            { items } = this.props,
            index = items.findIndex(item => item.id === defaultValue.id);

        if (~index) {
            const
                max = index + (MAX_PAGE / DOUBLE),
                min = index - (MAX_PAGE / DOUBLE),
                initItem = max > items.length ? items.length - MAX_PAGE : min;

            return initItem < INIT_INDEX ? INIT_INDEX : initItem;
        }

        return INIT_INDEX;
    }

    /**
     * Get the items to show in the table
     * @param {object} initItem The first item to show in the table
     * @returns {array} The array with the items to show in the table
     */
    getItemsPage(initItem) {
        const
            { items } = this.props;

        return items.slice(initItem, initItem + MAX_PAGE);
    }

    renderCols(row) {
        const
            ret = [],
            {initItem } = this.state,
            {textMenu, selectedDate} = this.props,
            items = this.getItemsPage(initItem);
        const RADIX = 10;

        for (let i = INIT_INDEX; i < COLS; i++) {
            const index = (row * COLS) + i;

            if (index === items.length) {
                break;
            }

            ret.push(
                <TableSelectorItem
                    key={i}
                    selectedYear={parseInt(textMenu, RADIX)}
                    selectedDate={selectedDate}
                    value={items[index]}
                    onClick={this.handleClick}
                />

            );
        }

        return ret;
    }

    renderRows() {
        const
            ret = [],
            { initItem } = this.state,
            items = this.getItemsPage(initItem);

        for (let i = INIT_INDEX; i < ROWS; i++) {

            if ((i * COLS) >= items.length) {
                break;
            }

            ret.push(
                <tr key={i}>
                    {this.renderCols(i)}
                </tr>
            );
        }

        return ret;
    }

    renderTextMenu() {
        const
            { initItem } = this.state,
            items = this.getItemsPage(initItem),
            first = items.shift(),
            last = items.pop();

        return `${first.text} - ${last.text}`;
    }

    renderMenu() {
        const { textMenu, onClickTitle } = this.props;
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();

        return (
            <div className="table-selector-menu">
                <Button
                    bsStyle="link"
                    onClick={this.handlePrevious}
                >
                    <Icon name="arrow-circle-left" />
                </Button>
                <Button
                    className="title"
                    onClick={onClickTitle}
                >
                    {textMenu || this.renderTextMenu()}
                </Button>
                <div className={_getArrowDisableClass(textMenu, currentYear)}>
                    <Button
                        bsStyle="link"
                        onClick={this.handleNext}
                    >
                        <Icon name="arrow-circle-right" />
                    </Button>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="table-selector">
                {this.renderMenu()}
                <Table>
                    <tbody>
                        {this.renderRows()}
                    </tbody>
                </Table>
            </div>
        );
    }
}


export default TableSelector;



// WEBPACK FOOTER //
// ./src/components/ui/form/dates/lib/TableSelector.jsx